var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDesignSelected = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#155DFC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M20.253 3.245 15.939 1.8a3.97 3.97 0 0 1-1.154 2.8 3.93 3.93 0 0 1-5.57 0A3.97 3.97 0 0 1 8.06 1.8L3.747 3.245c-.446.15-.824.454-1.066.859a2 2 0 0 0-.254 1.349L3 8.888a.99.99 0 0 0 .975.832H6.09v9.9a1.98 1.98 0 0 0 1.97 1.98h7.878c.523 0 1.024-.209 1.393-.58.37-.371.577-.875.577-1.4v-9.9h2.117a.98.98 0 0 0 .975-.832l.572-3.435a2 2 0 0 0-.255-1.35 1.97 1.97 0 0 0-1.065-.858"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#155DFC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "m8.909 14.892 2.638-2.64c.159-.158.238-.237.33-.266a.4.4 0 0 1 .247 0c.09.03.17.108.329.267l2.62 2.62M12.8 12.6l1.147-1.147c.159-.159.238-.238.33-.267a.4.4 0 0 1 .247 0c.09.03.17.108.329.267L16 12.6m-4.8-2.4a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0M9.92 15h4.16c.672 0 1.008 0 1.265-.13a1.2 1.2 0 0 0 .524-.525c.131-.257.131-.593.131-1.265V9.72c0-.672 0-1.008-.13-1.264a1.2 1.2 0 0 0-.525-.525c-.257-.13-.593-.13-1.265-.13H9.92c-.672 0-1.008 0-1.265.13a1.2 1.2 0 0 0-.524.525C8 8.712 8 9.048 8 9.72v3.36c0 .672 0 1.008.13 1.265a1.2 1.2 0 0 0 .525.524C8.912 15 9.248 15 9.92 15"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M7.2 6.6h9.6v9.6H7.2z"
})))));
export default SvgDesignSelected;